<template>
    <div>
        <div>
            <span style="padding-right:10px;font-size:16px">颜色:</span>
            <el-checkbox style="margin-bottom:5px" :indeterminate="isColorIndeterminate" v-show='tableData.colorList.length>1' v-model="checkColorAll" @change="handleCheckAllChange($event,'colorList','checkedColors','isColorIndeterminate')">全选</el-checkbox>
        </div>
        <el-checkbox-group v-model="checkedColors" @change="handleCheckedChange($event,'colorList','checkColorAll','isColorIndeterminate')">
            <el-checkbox style="margin-bottom:5px" v-for="color in tableData.colorList" :label="color" :key="color">{{color?color:'默认'}}</el-checkbox>
        </el-checkbox-group>
        <div style="margin-top:20px">
            <span style="padding-right:10px;font-size:16px">尺寸:</span>
            <el-checkbox style="margin-bottom:5px" :indeterminate="isSizeIndeterminate" v-show='tableData.sizeList.length>1' v-model="checkSizeAll" @change="handleCheckAllChange($event,'sizeList','checkedSizes','isSizeIndeterminate')">全选</el-checkbox>
        </div>
        <el-checkbox-group border v-model="checkedSizes" @change="handleCheckedChange($event,'sizeList','checkSizeAll','isSizeIndeterminate')">
            <el-checkbox style="margin-bottom:5px" v-for="size in tableData.sizeList" :label="size" :key="size">{{size?size:'默认'}}</el-checkbox>
        </el-checkbox-group>
        <div style="margin-top:20px;display:flex">
            <InNumber
                :datainfo="muti"
                :dataKey="'count'"
                :suffix="$global.pack"
                v-if="$global.buyType!=2"
                @changeEnd="changeEnd($event,muti,'count')"
            ></InNumber>
            <div style="margin-left:10px"></div>
            <InNumber
                :datainfo="muti"
                :dataKey="'num'"
                :suffix="$global.unit"
                v-if="$global.buyType!=1"
                @changeEnd="changeEnd($event,muti,'num')"
            ></InNumber>
            <el-button style="margin-left:10px" type="primary" @click="sure">确定</el-button>
            <el-button style="" type="info" @click="cancel">取消</el-button>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return {
            muti:{
                count:0,
                num:0,
            },
            checkedColors:[],
            checkedSizes:[],
            isColorIndeterminate:false,
            checkColorAll:false,
            isSizeIndeterminate:false,
            checkSizeAll:false,
        };
    },
    methods:{
        handleCheckAllChange(val,obj,arr,tar) {
            this[arr] = val ? this.tableData[obj] : [];
            this[tar] = false;
        },
        handleCheckedChange(value,obj,bb,tar) {
            let checkedCount = value.length;
            this[bb] = checkedCount === this.tableData[obj].length;
            this[tar] = checkedCount > 0 && checkedCount < this.tableData[obj].length;
        },
        changeEnd(e,obj,key){
            obj[key] = e;
        },
        sure(){
            if(this.checkedColors.length==0||this.checkedSizes.length==0){
                this.$common.info("没有选择样式");
                return;
            }
            let count = this.muti.count;
            let num = this.muti.num;
            if(count==0&&num==0){
                this.$common.info("没有输入数量");
                return;
            }
            for(let i in this.tableData.cols){
                if(this.checkedColors.indexOf(this.tableData.cols[i].name)>=0){
                    let col = this.tableData.cols[i];
                    for(let j in this.checkedSizes){
                        let size = this.checkedSizes[j];
                        col[size].count+=count;
                        col[size].num+=num;
                    }
                }
            }
            this.$emit("checkSpNumber");
            this.cancel();
        },
        cancel(){
            this.muti.count = 0;
            this.muti.num = 0;
            this.checkedSizes = [];
            this.checkedColors = [];
            this.isColorIndeterminate = false;
            this.checkColorAll = false;
            this.isSizeIndeterminate = false;
            this.checkSizeAll = false;
            this.$emit('close');
        }
    }
}
</script>

<style lang="less" scoped>
</style>